import { Pipe, PipeTransform } from '@angular/core';
import { DiscountType } from 'src/app/checkout/model/order.model';
import { PriceList } from '../../products/models/product.model';

@Pipe({ name: 'cashpoints', standalone: true })
export class CashpointsPipe implements PipeTransform {

  transform(priceList: PriceList): number {
    const cashPoints = priceList?.other_offers?.find(otherOffer => otherOffer.offer_type === DiscountType.CashPoints)?.cash_points;
    return cashPoints ? Math.floor(+cashPoints) : 0;
  }

}
